<div
  class="pill-switcher"
  [class.variant-brand]="variant === 'brand'"
  [class.single-selectable]="singleSelectable"
  role="radiogroup"
  [attr.aria-label]="ariaLabel || null"
  [style.--sg-pill-switcher-padding]="padding || null"
  [class.equal-width]="equalWidth"
  data-test="pill-switcher">
  <div #indicator class="indicator" data-test="pill-switcher-indicator"></div>
  @for (option of options; track option.value) {
  <button
    #segmentBtn
    class="segment"
    role="radio"
    [class.active]="option.value === value"
    [class.disabled]="option.disabled"
    [attr.aria-checked]="option.value === value"
    [attr.aria-disabled]="option.disabled || null"
    [disabled]="option.disabled"
    [attr.data-test]="'pill-switcher-option-' + option.value"
    (click)="select(option)">
    <sg-text variant="sg-label-medium-regular">{{ option.label }}</sg-text>
  </button>
  }
</div>
